import { useState } from "react";
import { Search, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, apiError } from "../../lib/api";
import { formatARS } from "../../lib/site";
import { PAY } from "./CashPanel";

export const ChargeButtons = ({ booking, onDone, dark = false }) => {
  const [busy, setBusy] = useState(false);
  const go = async (payment) => {
    if (!window.confirm(`¿Cobrar ${formatARS(booking.total)} en ${PAY[payment].toLowerCase()} y confirmar ${booking.code}?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/bookings/${booking.id}/charge`, { payment });
      toast.success(`Reserva ${data.code} cobrada`, { duration: 10000, action: { label: "Imprimir pasaje", onClick: () => window.open(`/admin/pasaje/${data.id}`, "_blank") } });
      onDone(data);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <span className={`text-xs font-semibold ${dark ? "text-white/80" : ""}`}>Cobrar:</span>
      {Object.entries(PAY).map(([k, l]) => (
        <button key={k} disabled={busy} onClick={() => go(k)} data-testid={`charge-${k}-${booking.code}`} className="rounded-full bg-amber-300 px-2.5 py-1 text-[11px] font-bold text-[var(--ink)] disabled:opacity-50">{l}</button>
      ))}
    </span>
  );
};

export const ChargeByCode = ({ onChanged }) => {
  const [code, setCode] = useState("");
  const [b, setB] = useState(null);
  const [loading, setLoading] = useState(false);
  const find = async (e) => {
    e.preventDefault();
    setLoading(true); setB(null);
    try { const { data } = await api.get(`/admin/bookings/by-code/${encodeURIComponent(code.trim())}`); setB(data); } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };
  return (
    <div data-testid="charge-by-code" className="rounded-2xl bg-white p-4 ring-1 ring-black/5">
      <form onSubmit={find} className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-bold">Cobrar una reserva</span>
        <Input data-testid="charge-code-input" placeholder="Código SG-XXXXXX" value={code} onChange={(e) => setCode(e.target.value)} className="h-10 w-48 font-mono uppercase" />
        <button data-testid="charge-code-search" disabled={!code.trim() || loading} className="inline-flex h-10 items-center gap-2 rounded-full bg-[var(--ink)] px-4 text-sm font-bold text-white disabled:opacity-40">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />} Buscar</button>
      </form>
      {b && (
        <div data-testid="charge-result" className="mt-3 flex flex-wrap items-center justify-between gap-3 rounded-xl bg-[var(--paper)] p-3 text-sm">
          <span><b className="font-mono">{b.code}</b> · {b.name} · DNI {b.dni} · {b.date} {b.departure} · {b.origin} → {b.destination} · butacas {b.seats.join(", ")} · <b>{formatARS(b.total)}</b></span>
          {b.status === "reservado"
            ? <ChargeButtons booking={b} onDone={(d) => { setB(d); onChanged?.(); }} />
            : <span data-testid="charge-status" className="rounded-full bg-white px-3 py-1 text-xs font-bold">{b.status === "confirmado" ? `Cobrado${b.payment ? ` · ${PAY[b.payment] ?? b.payment}` : ""}` : b.status === "vencida" ? "Reserva vencida: butacas liberadas" : b.status}</span>}
        </div>
      )}
    </div>
  );
};
